
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/escaping-the-build-trap",
      function () {
        return require("private-next-pages/books/escaping-the-build-trap.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/escaping-the-build-trap"])
      });
    }
  